import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type InputGroupTextComponentProps = {};

export type InputGroupTextProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, InputGroupTextComponentProps, "span">;

const InputGroupText = <T extends React.ElementType = "span">({
    className,
    tag,
    ...attributes
}: InputGroupTextProps<T>) => {
    const Tag = tag || ("span" as React.ElementType);

    return (
        <Tag
            {...attributes}
            className={cn(
                "tw:flex tw:items-center tw:mb-0 tw:text-base tw:px-2 tw:text-center tw:border-grey-input tw:border tw:bg-grey-light",
                "tw:rounded-sm!",
                "tw:group-[*]/inputgroup:not-first:rounded-l-none!",
                "tw:group-[*]/inputgroup:not-last:rounded-r-none!",
                "tw:group-[*]/inputgroup:not-last:-mr-px!",
                className
            )}
        />
    );
};

export { InputGroupText };
